import React, { useEffect, useState } from 'react';
import TemplateListHeader from './TemplateListHeader';
import TemplateItemList from './TemplateItemList';
import useCannedResponse from '../../../hooks/useCannedResponse';
import TemplateModal from '../modals/TemplateModal';
import useDisclosure from '../../../hooks/useDisclosure';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import TemplateAPIResponseModal from '../modals/TemplateAPIResponseModal';
import withModalWrapper from '../../../containers/common/WithModalWrapper';
import { modalConfig } from '../modals/modalConfig';
import { CannedCategory } from '../../../constants/common/CannedCategory';
interface ITemplateData {
    className: string;
    headerText: string;
    submitBtnText: string;
    initialFormValues: {};
    addNewTemplate?: (data: ITemplateRequest) => void;
    onClose: () => void;
    isEdit: boolean;
    templateCategoryName: string;
}

interface ITemplateRequest {
    templateName: string;
    templateSubject: string;
    templateContent: string;
    enableAsActive: boolean;
    templateCategoryId: number;
}

export const TEMPLATE_FORM_NAMES = {
    TEMPLATE_NAME: 'templateName',
    TEMPLATE_SUBJECT: 'templateSubject',
    TEMPLATE_CONTENT: 'templateContent',
    TEMPLATE_ENABLE_AS_ACTIVE: 'enableAsActive',
    TEMPLATE_CATEGORY_ID: 'templateCategoryId',
    TEMPLATE_ID: 'templateId',
};

const TemplateList = () => {
    const {
        template,
        cannedCategory = [],
        templateList = [],
        postSuccess,
        getCannedCategories,
        getCannedTemplatesList,
        postAddNewTemplate,
        postEditTemplate,
        errorMessage,
        resetAll,
        error,
        postTriggeredAt,
    } = useCannedResponse();

    const { isOpen: isOpenTemplateModal, onOpen: openTemplateModal, onClose: closeTemplateModal } = useDisclosure();

    const [customData, setCustomData] = useState<ITemplateData>();
    const [selectedItem, setSelectedItem] = useState(1);
    const [isActive, setActive] = useState(true);
    const [isUpdate, setUpdate] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(true);

    useEffect(() => {
        getCannedCategories();
    }, []);

    useEffect(() => {
        getTemplates();
    }, [selectedItem, postSuccess]);

    useEffect(() => {
        if (postSuccess) {
            closeTemplateModal();
        }
       
    }, [postSuccess]);

    useEffect(() =>{
        setShowErrorMessage(!postSuccess);
    },[postTriggeredAt, postSuccess]);

    const handleAPIModalClose = () => {
        setUpdate(false);
        closeTemplateModal();
    };

    const getTemplates = () => {
        const categoryId = selectedItem;
        getCannedTemplatesList(categoryId);
    };

    const handleSelection = item => {
        setSelectedItem(parseInt(item));
    };

    const handleActiveEnable = item => {
        setActive(item);
    };

    const addNewTemplate = async data => {
        resetAll();
        setShowErrorMessage(false);
        await postAddNewTemplate(data);
    };

    const updateTemplate = async data => {
        resetAll();
        setShowErrorMessage(false);
        await postEditTemplate(data);
    };

    const onErrorStatusChange = () =>{
        setShowErrorMessage(false);
    };

    const openModal = () => {
        resetAll();
        setUpdate(true);
        const INITIAL_TEMPLATE_FORM_VALUES = {
            [TEMPLATE_FORM_NAMES.TEMPLATE_NAME]: '',
            ...(selectedItem === CannedCategory.INTERNAL_COMMENT
                ? {}
                : { [TEMPLATE_FORM_NAMES.TEMPLATE_SUBJECT]: '' }
            ),          
            [TEMPLATE_FORM_NAMES.TEMPLATE_CONTENT]: '',
            [TEMPLATE_FORM_NAMES.TEMPLATE_CATEGORY_ID]: selectedItem,
            [TEMPLATE_FORM_NAMES.TEMPLATE_ENABLE_AS_ACTIVE]: true,
            [TEMPLATE_FORM_NAMES.TEMPLATE_ID]: '',
        };
        const data = {
            className: 'ticket_management',
            headerText: 'ticket_management.create_new_template',
            submitBtnText: 'ticket_management.template_form.save',
            initialFormValues: INITIAL_TEMPLATE_FORM_VALUES,
            addNewTemplate: addNewTemplate,
            onClose: closeTemplateModal,
            isEdit: false,
            templateCategoryName: selectedItem,
        };
        setCustomData(data);
        openTemplateModal();
    };

    const editModal = template => {
        resetAll();
        setUpdate(true);
        const INITIAL_TEMPLATE_FORM_VALUES = {
            [TEMPLATE_FORM_NAMES.TEMPLATE_NAME]: template.templateName,
            ...(selectedItem === CannedCategory.INTERNAL_COMMENT
                ? {}
                : { [TEMPLATE_FORM_NAMES.TEMPLATE_SUBJECT]: template.templateSubject }
            ),
            [TEMPLATE_FORM_NAMES.TEMPLATE_CONTENT]: template.templateContent,
            [TEMPLATE_FORM_NAMES.TEMPLATE_CATEGORY_ID]: template.templateCategoryId,
            [TEMPLATE_FORM_NAMES.TEMPLATE_ENABLE_AS_ACTIVE]: template.enableAsActive,
            [TEMPLATE_FORM_NAMES.TEMPLATE_ID]: template.templateId,
        };
        const data = {
            className: 'ticket_management',
            headerText: 'ticket_management.edit_template',
            submitBtnText: 'ticket_management.custom_field.update_btn',
            initialFormValues: INITIAL_TEMPLATE_FORM_VALUES,
            updateTemplate: updateTemplate,
            onClose: closeTemplateModal,
            isEdit: true,
            templateCategoryName: selectedItem,
        };
        setCustomData(data);
        openTemplateModal();
    };

    return (
        <div className="gi-panel">
            <TemplateListHeader
                {...{
                    openModal,
                    cannedCategory,
                    handleSelection,
                    handleActiveEnable,
                }}
            />
            <TemplateItemList
                {...{
                    isActive,
                    editModal,
                    getCannedTemplatesList,
                    templateList,
                    selectedItem,
                }}
            />
            <ConditionalRendering isTrue={isOpenTemplateModal}>
                <TemplateModal modalData={customData} errorMessage={errorMessage} onErrorStatusChange={onErrorStatusChange} showErrorMessage={showErrorMessage} />
            </ConditionalRendering>
            <ConditionalRendering isTrue={isUpdate && postSuccess}>
                <TemplateAPIResponseModal
                    message={errorMessage}
                    submitBtnText={'dashboard.ok'}
                    headerId={error?'bob.transfer.validation_error':'bob.transfer.success'}
                    onClose={handleAPIModalClose}
                />
            </ConditionalRendering>
        </div>
    );
};
export default withModalWrapper(TemplateList, modalConfig);
